import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-prescription",
  templateUrl: "./prescription.component.html",
  styleUrls: ["./prescription.component.sass"],
})
export class PrescriptionComponent implements OnInit {

  displayedColumns = [
    "select",
    "img",
    "name",
    "gender",
    "address",
    "mobile",
    "date",
    "bGroup",
    "treatment",
    "actions",
  ];

  constructor() {}

  ngOnInit(): void {}

  removeSelectedRows() {}
  addNew() {}
  refresh() {}
  editCall(row) {}
}
